// @ts-strict-ignore
import qs from 'query-string';

const parseQueryString = query => (query ? qs.parse(query) : {});

const addParams = (search: string, params) => {
  const urlParams = qs.parse(search);
  const withNew = { ...urlParams, ...params };
  const hydratedSearch = qs.stringify(withNew);
  return hydratedSearch ? `?${hydratedSearch}` : '';
};

const removeParams = (search: string, params: string | string[]): string => {
  const parsedSearch = qs.parse(search);
  params = typeof params === 'string' ? [params] : params;
  params.forEach(key => {
    delete parsedSearch[key];
  });
  const filteredSearch = qs.stringify(parsedSearch);
  return filteredSearch === '' ? filteredSearch : `?${filteredSearch}`;
};

export { parseQueryString, addParams, removeParams };
